// extracted by mini-css-extract-plugin
export default {"tooltip":"zV-z","arrow":"AV-z"};